import { render } from "./ItemsPerPage.vue?vue&type=template&id=5816059d"
import script from "./ItemsPerPage.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ItemsPerPage.vue?vue&type=script&charset=utf-8&lang=js"

import "./ItemsPerPage.vue?vue&type=style&index=0&id=5816059d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__